import { Component, Input } from '@angular/core';

@Component({
  selector: 'insight-section-wrapper',
  template: `
    <div class="container" [style.border-width]="borderInPx + 'px'" [style.border-radius]="borderRadius + 'px'">
      <div
        *ngIf="sectionTitle"
        class="section-title"
        [style.font-size]="fontSize"
        [style.height]="height"
        [style.padding-top]="paddingTop"
        [style.padding-bottom]="paddingBottom"
        [style.border-radius]="borderRadius + 'px'"
        [style.background-color]="backgroundColor"
        [class.title-bottom-border]="titleBottomBorder"
      >
        <span *ngIf="uppercaseTitle" [innerHTML]="sectionTitle | trustAsSafeHtml"></span>
        <span *ngIf="!uppercaseTitle" [innerHTML]="sectionTitle | trustAsSafeHtml"></span>
      </div>
      <div>
        <ng-content></ng-content>
      </div>
    </div>
  `,
  styles: [
    `
      .container {
        border-color: #e4e4e4;
        border-style: solid;
        overflow: hidden;
      }
      .section-title {
        font-weight: 800;
        padding-left: 20px;
      }
      .title-bottom-border {
        border-bottom: 1px solid #e4e4e4;
      }
    `,
  ],
})
export class InsightSectionWrapperComponent {
  @Input() sectionTitle: string = '';
  @Input() uppercaseTitle: boolean = true;
  @Input() titleBottomBorder: boolean = false;

  @Input() fontSize: string = '18px';
  @Input() borderInPx: number = 1;
  @Input() borderRadius: number = 6;
  @Input() backgroundColor: string = '#f2f2f2';
  @Input() height: string = '32px';
  @Input() paddingTop: string = '9px';
  @Input() paddingBottom: string = '1px';
}
